import React from "react";

import { colorsV2 } from "../../styles/colors";

export default (props) => {
  return (
    <div
      style={{
        margin: 20,
        width: 150,
        height: 75,
        borderRadius: 10,
        border: "solid 2px",
        borderColor:
          props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
            ? props.whiteLabelSettings.primaryColor
            : colorsV2.bunting,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "1px 3px 1px #9E9E9E",
      }}
    >
      <h4
        style={{
          textAlign: "center",
          margin: 0,
          padding: 0,
          color:
            props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
              ? props.whiteLabelSettings.primaryColor
              : colorsV2.primary,
        }}
      >
        {props.title}
      </h4>
      <p
        style={{
          textAlign: "center",
          margin: 0,
          padding: 0,
          fontSize: 18,
          color:
            props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
              ? props.whiteLabelSettings.accentColor
              : colorsV2.lightningYellow,
          fontFamily: "Poppins-SemiBold",
        }}
      >
        {props.score && parseFloat(props.score).toFixed(2)}%
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/NPSScoreSmall.js